var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hotspot-ui',_vm._g({staticClass:"vca-game-hotspot",class:{
    found: _vm.found,
  },attrs:{"spot-config":_vm.spotConfig,"action":_vm.action}},( _obj = {}, _obj[_vm.action.type] = _vm.execAction, _obj )),[_c('img',{attrs:{"src":_vm.gemImage,"alt":(_vm.gemColor + "-gem")}})])}
var staticRenderFns = []

export { render, staticRenderFns }